import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import useFetch from '../../hooks/useFetch';
import Loader from '../../components/utils/Loader';
import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faTrash } from '@fortawesome/free-solid-svg-icons';
import './DocSure.css';

const DocSureAccessed = () => {
  const authState = useSelector(state => state.authReducer);
  const [fetchData, { loading }] = useFetch();
  const [products, setDocuments] = useState([]);
  const [error, setError] = useState('');
  
  useEffect(() => {
    const fetchDocuments = async () => {
      setError('');
      try {
        const response = await fetchData(`/api/docSureBank/search?scannedName=${encodeURIComponent(authState.user.name)}`);
        setDocuments(response.data);
      } catch (err) {
        setError('Error fetching data.');
        console.error(err);
      }
    };

    fetchDocuments();
  }, [authState.user.name, fetchData]);

  return (
    <MainLayout>
      <div>
        <h2 className='text-lg mt-1 mx-8 border-b border-b-gray-300 text-white'>DocSure - My List</h2>
      </div>
      <div className="m-auto my-2 p-2 px-4 border-2 shadow-md rounded-md md:w-7/12 w-full">
        <h1 className='text-3xl font-bold text-white mb-4'>My Accessed Doc</h1>

        {loading && <Loader />}
        {error && <p className='text-red-500'>{error}</p>}

        {products.length > 0 ? (
          <table className='w-full bg-white border border-gray-200 rounded-md'>
            <thead className='bg-gray-100'>
              <tr>
                <th className='p-2 border-b border-gray-300 text-left'>Document Code</th>
                <th className='p-2 border-b border-gray-300 text-left'>Document Name</th>
                <th className='p-2 border-b border-gray-300 text-left'>Brand</th>
                <th className='p-2 border-b border-gray-300 text-left'>Batch Number</th>
                <th className='p-2 border-b border-gray-300 text-left'>Manufacture Date</th>
                <th className='p-2 border-b border-gray-300 text-left'>Expiry Date</th>
                <th className='p-2 border-b border-gray-300 text-left'>Document Brief</th>
                <th className='p-2 border-b border-gray-300 text-left'>Scanned City</th>
                <th className='p-2 border-b border-gray-300 text-left'>Scanned PIN</th>
                <th className='p-2 border-b border-gray-300 text-left'>Actions</th>
              </tr>
            </thead>
            <tbody>
              {products.map((product) => (
                <tr key={product.productCode}>
                  <td className='p-2 border-b border-gray-300'>{product.productCode}</td>
                  <td className='p-2 border-b border-gray-300'>{product.productName}</td>
                  <td className='p-2 border-b border-gray-300'>{product.productBrand}</td>
                  <td className='p-2 border-b border-gray-300'>{product.batchNumber}</td>
                  <td className='p-2 border-b border-gray-300'>{new Date(product.mfgDate).toLocaleDateString()}</td>
                  <td className='p-2 border-b border-gray-300'>{new Date(product.expDate).toLocaleDateString()}</td>
                  <td className='p-2 border-b border-gray-300'>{product.productBrief}</td>
                  <td className='p-2 border-b border-gray-300'>{product.scannedCity}</td>
                  <td className='p-2 border-b border-gray-300'>{product.scannedPIN}</td>
                  <td className='p-2 border-b border-gray-300'>
                    <button className='text-red-500 hover:text-red-700'>
                      <FontAwesomeIcon icon={faTrash} />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p className='text-white'>No document found.</p>
        )}
      </div>
    </MainLayout>
  );
};

export default DocSureAccessed;
